import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCited = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 30 22",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.65 6.68V7.7a.14.14 0 010 .11c-.13 1.42-.47 2.81-1.01 4.13a15.73 15.73 0 01-2.7 4.54 15.87 15.87 0 01-3.96 3.4c-1.45.86-3 1.53-4.63 1.98 0 0 2.84-4.15 5.8-8.2h-.3a6.82 6.82 0 116.8-6.98zM30 6.68V7.81c-.13 1.42-.48 2.81-1.02 4.13a15.73 15.73 0 01-2.68 4.56 15.86 15.86 0 01-3.96 3.33 18.29 18.29 0 01-4.68 1.99s2.83-4.13 5.79-8.18h-.3A6.82 6.82 0 1130 6.68z" })
});
export default SvgCited;
